<div class="flex bg-slate-200" (window:keydown.enter)="onSubmit()">

    <!-- Content -->
    <div class="h-screen flex-[7] flex flex-col justify-center">
        <div class="flex flex-col">
            <div class="space-y-8 px-[3rem] sm:px-[9rem] md:px-[12rem] lg:px-[14rem] xl:px-[16rem] 2xl:px-[18rem]">
                <button
                    (click)="goBack()"
                >
                    <img src="assets/images/left_arrow.png" alt="back" [width]="20">
                </button>

                <p class="text-2xl sm:text-3xl lg:text-2xl xl:text-4xl font-bold">A pagar com "{{paymentMethod}}"</p>
    
                <div class="space-y-3">
                    <p class="text-sm md:text-base">
                        Comerciante: 
                        <span class="font-bold">{{linkInfo.store_name}}</span>
                    </p>
                    <p class="text-2xl md:text-3xl">
                        <span class="font-bold">{{ linkInfo.amount | currency: '': '':'1.2-2' }}</span>
                        <span> MZN </span>
                    </p>
                </div>
            </div>
        </div>

        <form class="flex justify-center py-10">
            <app-input-field
                [label]="paymentMethod==='iMali' ? 'Número de telefone ou conta' : 'Número de telefone'"
                [value]="paymentNumber()"
                (valueChange)="paymentNumber.set($event)"
                [pattern]="getPattern()"
                [maxLength]="9"
                [startValidate]="submited"
                [errorMessage]="paymentMethod==='iMali' ? 'Número de telefone ou conta esta invalido!' : 'Número de telefone invalido!'"
                
            ></app-input-field>
        </form>

        <div class="flex justify-center py-20">
            <div class="w-[50vw] lg:w-[25vw]">
                <button 
                    type="submit"
                    (click)="onSubmit()"
                    class="w-full py-2 rounded-full bg-customGreen text-xl text-white"
                >
                    Continuar
                </button>
            </div>
        </div>
    </div>

    <!-- Right Panel -->
    <div class="flex-[3] hidden lg:block">
        <div class="flex flex-col justify-around items-center h-screen rounded-s-[2rem] bg-white drop-shadow-md">
            <div>
                <img src="assets/images/imali_logo.png" alt="imali_logo" class="w-20">
                <p class="py-10">Aproveita o teu dinheiro da melhor forma.</p>
                <a href="https://imali.co.mz/" target="_blank" class="underline">Saber Mais</a>
            </div>
        </div>
    </div>
</div>
